export const attachedFiles = [
  {
    id: 1,
    icon: 'fileAttached',
    fileName: 'Anexo.doc',
    fileSize: '241 KB',
  },
  {
    id: 2,
    icon: 'fileAttached',
    fileName: 'Anexo2.doc',
    fileSize: '241 KB',
  },
];
